import { Action, Reducer } from 'redux';
import { AppThunkAction } from './';
import config from './config';

let base = config.api;


// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface LoginState {
    isLoggedIn: boolean;
    loggingIn: boolean;
    token?: string;
    reconcile: boolean;
}

interface LoginResponse {
    token: string;
    reconcile: boolean;
}

interface LoginCompletedPayload extends LoginResponse {}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

export interface LoginAction { type: 'LOGIN' }
export interface LoginCompletedAction { type: 'LOGIN_COMPLETED', payload: LoginCompletedPayload }
export interface LoginFailedAction { type: 'LOGIN_FAILED' }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = LoginAction | LoginCompletedAction | LoginFailedAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    login: (userName: string, password: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        fetch("api/login/authenticate", {method:"post", headers:{ "Content-Type": "application/json" }, body: JSON.stringify({userName, password})})
            .then(response => response.ok ? response.json() as Promise<LoginResponse> : Promise.resolve({token:"error"}) as Promise<LoginResponse>)
            .then(data => {
                if (data.token === "error") {
                    dispatch({ type: 'LOGIN_FAILED' });
                }else{
                    dispatch({ type: 'LOGIN_COMPLETED', payload: {...data} });
                }
            });
       dispatch({ type: 'LOGIN' });
    },
    verify: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        fetch(base+"/api/login/authenticate", { credentials: "include" , method:"post", headers:{ "Content-Type": "application/json" }, body: JSON.stringify({userName:"", password:""})})
            .then(response => response.ok ? response.json() as Promise<LoginResponse> : Promise.resolve({token:"error"}) as Promise<LoginResponse>)
            .then(data => {
                if (data.token === "error") {
                    dispatch({ type: 'LOGIN_FAILED' });
                }else{
                    dispatch({ type: 'LOGIN_COMPLETED', payload:{...data} });
                }
            });
            dispatch({ type: 'LOGIN' });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

export const reducer: Reducer<LoginState> = (state: LoginState | undefined, incomingAction: Action): LoginState => {
    if (state === undefined) {
        return { isLoggedIn: false, loggingIn: false, reconcile: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "LOGIN": 
            return {...state, loggingIn: true}
        case "LOGIN_COMPLETED":
            console.log("Login completed")
            return {...state, loggingIn: false, isLoggedIn: true, token: action.payload.token, reconcile: action.payload.reconcile}
        case "LOGIN_FAILED":
            return {...state, loggingIn: false, isLoggedIn: false}
        default:
            return state;
    }
};
